import React from 'react';
import { Link } from 'react-router-dom';
import { COLORS } from '../../../styles/tokens';
import { termsSummary } from '../../../utils/terms';

export const TERMS_REQUIRED_MESSAGE = 'Du må godta vilkårene for å bestille';

// Kort sammendrag av vilkårene (ventetid, bomtur, avbestilling) med lenke til hele siden.
// Med `needsAcceptance` må bestilleren krysse av før oppdraget kan publiseres.
export default function TermsNotice({ terms, needsAcceptance, accepted, onChange, showError }) {
  return (
    <div style={styles.box}>
      <div style={styles.title}>Vilkår for ventetid, bomtur og avbestilling</div>
      <ul style={styles.list}>
        {termsSummary(terms).map(line => <li key={line}>{line}</li>)}
      </ul>
      <Link to="/vilkar" style={styles.link}>Les alle vilkårene</Link>
      {needsAcceptance && (
        <label style={styles.check}>
          <input
            type="checkbox"
            checked={!!accepted}
            onChange={e => onChange(e.target.checked)}
          />
          <span>Jeg godtar vilkårene</span>
        </label>
      )}
      {needsAcceptance && showError && <div style={styles.error}>{TERMS_REQUIRED_MESSAGE}</div>}
    </div>
  );
}

const styles = {
  box: { background: COLORS.warningBg, border: `1px solid ${COLORS.accent}`, borderRadius: 16, padding: 14, fontSize: 13, color: COLORS.textMid },
  title: { fontWeight: 700, fontSize: 14, color: COLORS.textDark, marginBottom: 6 },
  list: { margin: '0 0 8px', paddingLeft: 18, lineHeight: 1.5 },
  link: { color: COLORS.brandPanel, fontWeight: 600, fontSize: 13 },
  check: { display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, fontWeight: 600, color: COLORS.textDark, fontSize: 14 },
  error: { marginTop: 6, color: COLORS.dangerText, fontSize: 13, fontWeight: 600 },
};
